import React from "react";

function DropdownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 122.88 66.91"
      version="1.1"
      viewBox="0 0 122.88 66.91"
      xmlSpace="preserve"
    >
      <path
        d="M11.68 1.95a6.884 6.884 0 0 0-9.73.13 6.884 6.884 0 0 0 .13 9.73l54.79 53.13 4.8-4.93-4.8 4.95a6.9 6.9 0 0 0 9.75-.15c.08-.08.15-.16.22-.24l53.95-52.76a6.875 6.875 0 0 0 .14-9.73c-2.65-2.72-7.01-2.79-9.73-.13L61.65 50.41 11.68 1.95z"
        fill="#00bafa"
      />
    </svg>
  );
}

export default DropdownIcon;
